import { ROUTES } from "../constants";
import Dashboard from "../views/Dashboard/Dashboard";
import ThankYou from "../views/Customer/EventBooking/Tabs/ThankYou";
import EventThankYou from "../views/Customer/EventBooking/Tabs/EventThankYou";
import CustomerDashboard from "../views/Customer/CustomerDashboard/CustomerDashboard";
import ShutterbDashboard from "../views/Shutterb/ShutterbDashboard/ShutterbDashboard";
import MyEventsDashboard from "../views/Customer/CustomerDashboard/CustomerDashboardTabs/MyEventsTab/MyEventsDashboard/MyEventsDashboard";
import GroupEventsDashboard from "../views/Customer/CustomerDashboard/CustomerDashboardTabs/MyEventsTab/GroupEventsDashboard/GroupEventsDashboard";

export const userRoutes = [
  {
    screenId: 1,
    path: `/Dashboard`,
    component: Dashboard,
  },
  {
    screenId: 2,
    path: `/CustomerDashboard`,
    component: CustomerDashboard,
  },
  {
    screenId: 3,
    path: "/EventBookRequested/:id/:orderItemGroupId/:isNewBooking/:CheckoutStatus",
    component: ThankYou,
  },
  {
    screenId: 4,
    path: `/CustomerDashboardTab/MyEvents/:groupEventId/:eventId?/:tab`,
    component: MyEventsDashboard,
  },
  {
    screenId: 5,
    path: `/CustomerDashboard_/:tab`,
    component: CustomerDashboard,
  },
  {
    screenId: 6,
    path: ROUTES.EVENT_THANK_YOU,
    component: EventThankYou,
  },
  {
    screenId: 7,
    path: "/EventBookRequested",
    component: ThankYou,
  },
  {
    screenId: 8,
    path: `/CustomerDashboardTab/GroupEvents/:eventGroupId/:tab`,
    component: GroupEventsDashboard,
  },
];

export const sbRoutes = [
  {
    screenId: 1,
    path: `/Dashboard`,
    component: Dashboard,
  },
  {
    screenId: 2,
    path: `/ShutterbDashboard`,
    component: ShutterbDashboard,
  },
  {
    screenId: 3,
    path: `/ShutterbDashboard_/:tab`,
    component: ShutterbDashboard,
  },
  {
    screenId: 4,
    path: `/ShutterbDashboardTab/:tab/:nestedTab`,
    component: ShutterbDashboard,
  },
];
